import React from 'react';
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/system";
import logo from "../../assets/logo.png";
import logoDark from "../../assets/logo_dark.png";
import icon from "../../assets/casablanca_icon.png";

const CasablancaLogo = () => {
  const theme = useTheme();
  return (
    <>
    {/* For small devices */}
    <Box display={{ xs: "block", sm: "none" }}>
        <img src={icon} alt="Icon" height="40" />
    </Box>

    {/* For devices larger than small */}
    <Box display={{ xs: "none", sm: "block" }}>
        {theme.palette.mode === "dark" ? (
            <img src={logoDark} alt="Company Logo" height="35" style={{marginLeft: 8}}/>
        ) : (
            <img src={logo} alt="Company Logo" height="50" />
        )}
    </Box>
</>
  );
};

export default CasablancaLogo;
